// db/validators.ts
import "@adornis/baseql/entities/adornisEntity";
import { ValidationError } from "@adornis/validation/errors/ValidationError";
var nameRegexCheck = (name) => /^[A-Za-z0-9_^\-+.@]+$/.test(name);
var passwordRegexCheck = (password) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\?\.\-])(?=.{8,})/.test(password);
var emailRegexCheck = (email) => /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i.test(
  email
);
var nameValidation = (fieldValue, key, instance) => {
  if (!nameRegexCheck(fieldValue)) {
    throw new ValidationError(`Username can only contain alphanumeric values and _ or -`, {
      key,
      instance,
      translationKey: "invalid_username"
    });
  }
};
var validatePassword = (password, key, instance) => {
  if (!passwordRegexCheck(password)) {
    throw new ValidationError(
      `Password must contain atleast 8 characters, one uppercase letter, one lowercase, one number and one special character`,
      { key: key ?? "password", instance, translationKey: "password_strength_insufficient" }
    );
  }
};
var passwordValidation = (fieldValue, key, instance) => validatePassword(fieldValue, key, instance);
var emailValidation = (fieldValue, key, instance) => {
  if (fieldValue !== null && fieldValue !== void 0 && (fieldValue.length < 6 || !emailRegexCheck(fieldValue))) {
    throw new ValidationError(`Email ${fieldValue} is not valid.`, { key, instance, translationKey: "invalid_email" });
  }
};
export {
  emailRegexCheck,
  emailValidation,
  nameRegexCheck,
  nameValidation,
  passwordRegexCheck,
  passwordValidation,
  validatePassword
};
